import React, { useState, useEffect } from "react";
import { GeneralFooter } from "../../../components/generalFooter/GeneralFooter";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import "./PaymentFailed.css";
import CloseIcon from "@mui/icons-material/Close";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { useNavigate, useLoaderData, useSearchParams } from "react-router-dom";
import { paymentStatus } from "../../../services/payment";
import Typography from "@mui/material/Typography";
import toast from "react-hot-toast";
import { timestampToDateTime } from "../../../utils";
import CircularProgress from "@mui/material/CircularProgress";
import { trackPaymentFailed } from "../../../utils/analytics";
import { formatEuroCurrency } from "../../../utils/currency";

export const PaymentFailed = () => {
  const navigate = useNavigate();
  const user = useLoaderData();
  let [searchParams] = useSearchParams();
  let orderId = searchParams.get("transaction_id");
  let sessionId = searchParams.get("session_id");
  const [loading, setLoading] = useState(true);
  const [statusData, setStatusData] = useState(null);

  const getPaymentStatus = async () => {
    const res = await paymentStatus(user?.token, sessionId);
    // console.log("payment status res: ", res);

    if (res?.status === true) {
      setStatusData(res?.data);

      // Track failed payment
      trackPaymentFailed(orderId, res?.data?.amount_total / 100, "Payment declined or cancelled");

      setLoading(false);
      return;
    }

    if (res?.status === false) {
      if (res.message === "Invalid or expired access token.") {
        toast.error("Token expired Please re-login and try");
        setLoading(false);
        return;
      }

      toast.error("Something went wrong, please try again later.");
      setLoading(false);
      return;
    }

    toast.error("Something went wrong, please try again later.");
    setLoading(false);
    return;
  };

  useEffect(() => {
    if (sessionId) {
      getPaymentStatus();
      return;
    }
    return;
  }, [sessionId]);

  return (
    <>
      <MooringMateHomeHeader />
      <div className="payContainer">
        {sessionId ? (
          loading ? (
            <div className="loaderParent">
              <CircularProgress />
            </div>
          ) : (
            <div className="failure-container">
              <div className="failure-icon">
                <CloseIcon sx={{ color: "white" }} fontSize="large" />
              </div>
              <h1 className="failedTxt">Payment Failed</h1>
              <p className="pay-failed-text">
                We couldn't process your payment. Please check your payment
                details and try again.
              </p>

              <div className="error-details">
                <div className="detail-row">
                  <span className="detail-label">Order ID:</span>
                  <span className="detail-value">{orderId}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Date and time:</span>
                  <span className="detail-value">
                    {timestampToDateTime(statusData?.created)}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Amount:</span>
                  <span className="detail-value">
                    {formatEuroCurrency(statusData?.amount_total / 100)}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Transaction ID:</span>
                  <span className="detail-value" style={{ overflowX: "scroll" }}>
                    {statusData?.id}
                  </span>
                </div>
              </div>

              <p className="pay-failed-text">
                Reasons for failure might include insufficient funds, incorrect
                card details, or bank restrictions.
              </p>

              <div className="btn-group">
                <button
                  className="btn btn-retry"
                  onClick={() => window.location.replace(statusData?.url)}
                >
                  Retry Payment
                </button>
                <button
                  className="btn btn-alternate"
                  onClick={() => navigate("/home")}
                >
                  Continue to Dashboard
                </button>
              </div>

              {/* <div className="support-note">
                <SupportAgentIcon fontSize="small" />{" "}
                <span>
                  Need help?{" "}
                  <a style={{ color: "#f44336", textDecoration: "none" }}>
                    Contact support
                  </a>
                </span>
              </div> */}
            </div>
          )
        ) : (
          <div style={{ height: "60vh" }}>
            <Typography component="h1" variant="h4" align="center">
              You don't have access to this page
            </Typography>
          </div>
        )}
      </div>
      <GeneralFooter />
    </>
  );
};
